import { StrictMode } from 'react'
// 多言語対応（i18n）の設定を読み込む
import './i18n'
import { createRoot } from 'react-dom/client'
// サイト全体の共通デザイン（CSS）を読み込む
import './index.css'
// メインの画面コンポーネントを読み込む
import App from './App.tsx'
// 画像の自動フォールバック（/img/ に無ければ Supabase Storage から読む）を有効化
import { installImageFallback } from './lib/imageFallback'

installImageFallback()

// index.htmlのid="root"の中身に、Reactの画面を描画する
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)